export default "__VITE_ASSET__BI3hSLpk__"